import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSubscription } from "../context/SubscriptionContext";
import { api } from "../lib/api";
import { toast } from "sonner";
import { PenNib, ArrowLeft } from "@phosphor-icons/react";
import TierPricing from "../components/TierPricing";

const ACCENT = "#FFD60A";

export default function Pricing() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { sub } = useSubscription();

  const choose = async (planId) => {
    if (!user) {
      localStorage.setItem("pending_plan_id", planId);
      navigate("/signup");
      return;
    }
    try {
      const r = await api.post("/payments/checkout", { plan_id: planId, origin_url: window.location.origin });
      if (r.data.url) { window.location.href = r.data.url; return; }
      toast.error("Could not start checkout.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout. Please try again.");
    }
  };

  const topup = async (packId) => {
    if (!user) {
      localStorage.setItem("pending_topup", packId);
      navigate("/signup");
      return;
    }
    try {
      const r = await api.post("/billing/topup", { pack_id: packId, origin_url: window.location.origin });
      if (r.data.url) { window.location.href = r.data.url; return; }
      toast.error("Could not start checkout.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-[#070707] text-white font-body overflow-x-hidden">
      <nav className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <button data-testid="pricing-home-btn" onClick={() => navigate("/")} className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: ACCENT }}><PenNib weight="fill" size={18} className="text-black" /></div>
            <span className="font-display font-extrabold text-lg tracking-tight">FlyerStudio</span>
          </button>
          {user ? (
            <button data-testid="pricing-dashboard-btn" onClick={() => navigate("/dashboard")} className="text-sm font-bold px-4 py-2 rounded-full transition-transform hover:scale-105" style={{ backgroundColor: ACCENT, color: "#0a0a0a" }}>Dashboard</button>
          ) : (
            <button data-testid="pricing-signin-btn" onClick={() => navigate("/login")} className="text-sm font-semibold text-zinc-200 hover:text-white px-3 py-2">Sign in</button>
          )}
        </div>
      </nav>

      <header className="relative px-6 pt-20 pb-12 text-center overflow-hidden">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-[420px] w-[640px] rounded-full bg-fuchsia-600/10 blur-[140px] pointer-events-none" />
        <div className="relative max-w-2xl mx-auto">
          <button onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-6 transition-colors"><ArrowLeft size={15} /> Back to homepage</button>
          <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mb-4">Plans that scale with your nightlife.</h1>
          <p className="text-zinc-400 text-lg">Start free, upgrade when you sell out. Switch monthly or save with annual — cancel anytime.</p>
        </div>
      </header>

      <main className="px-6 pb-24">
        <TierPricing onChoose={choose} onTopup={topup} currentTier={sub?.tier} currentBilling={sub?.billing} />
        <p className="text-center text-sm text-zinc-500 mt-12">
          Just exploring?{" "}
          <button onClick={() => (user ? navigate("/dashboard") : navigate("/signup"))} className="font-bold hover:underline" style={{ color: ACCENT }}>
            {user ? "Go to your dashboard" : "Create a free account"} →
          </button>
        </p>
      </main>

      <footer className="border-t border-white/10 py-8 px-6">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-zinc-600">
          <span>© 2026 FlyerStudio. Club-ready flyers in one prompt.</span>
          <button onClick={() => navigate("/")} className="hover:text-zinc-300">Home</button>
        </div>
      </footer>
    </div>
  );
}
